import React, { useState, Fragment } from 'react';
import Table from './Table';
import TableCard from './TableCard';
import '../../../styles/css/Table.css';
import LoadingIndicator from '../LoadingIndicator';
import TablePaginationContainer from './TablePaginationContainer';

const TableContainer = (props) => {
  const {
      renderAction,
      action,
      translations,
      gt,
      tableId,
      tableConfig,
      items,
      page,
      rowsPerPage,
      totalElements,
      setActivePage,
      setPageSize,
      loading,
      removeSearch,
      actionButtonStyle,
      titleTag,
      tableCardStyle,
      renderCardHeader,
      customRow,
      customHeader,
      smallSearchSignal,
      cellValue,
      setCellValue,
    } = props || {},
    { tableTitle, Tooltips, HeaderColumns } = translations || {},
    { EnhancedTable } = gt || {};
  const [data, setData] = useState(null);
  const activePage = data ? 0 : page;
  const pageSize = rowsPerPage;
  const numberOfElements = data ? data.length : totalElements;
  
  return (
    <Fragment>
      <TableCard
        title={tableTitle}
        renderAction={renderAction}
        actionButtonStyle={actionButtonStyle}
        action={action}
        tooltipText={Tooltips?.addItem}
        items={items}
        setData={setData}
        columns={tableConfig?.columns}
        removeSearch={removeSearch}
        titleTag={titleTag}
        tableCardStyle={tableCardStyle}
        renderCardHeader={renderCardHeader}
        customHeader={customHeader}
        smallSearchSignal={smallSearchSignal}
      >
        <LoadingIndicator
          loading={loading}
          showOnComponentLevel
          spinnerSize={110}
        />
        {!loading && (
          <Table
            config={tableConfig}
            id={tableId}
            items={data || items}
            translations={HeaderColumns}
            page={page}
            rowsPerPage={rowsPerPage}
            customRow={customRow}
            cellValue={cellValue}
            setCellValue={setCellValue}
          />
        )}
      </TableCard>
      {!!rowsPerPage && (
        <TablePaginationContainer
          totalElements={numberOfElements}
          activePage={activePage}
          pageSize={pageSize}
          setActivePage={setActivePage}
          setPageSize={setPageSize}
          translations={EnhancedTable}
        />
      )}
    </Fragment>
  );
};

export default TableContainer;
